import React, { Component } from 'react';
import Gis from './sig/Container/GIS_SCREEN';
import Landing from './../landing/containers/LandingContainer';


class HocDashboard extends Component {
    render() {
        return (
            <Landing history={this.props.history} hasFooter={false}>
                <Gis />
            </Landing>
            
        );
    }
}

export default HocDashboard;